<div class="flex flex-col h-full">
  <div class="flex w-full mt-3">
    <modus-label class="text-xs grow">{{ translations.eyeDomeLighting.text }}</modus-label>
    <modus-switch
      id="3d-settings-eye-dome-toggle"
      [formControl]="formGroup.controls.showEyeDomeLighting"
    ></modus-switch>
  </div>

  <div class="flex w-full items-center">
    <modus-label class="text-xs grow select-none" (click)="showExperimentalClick($event)">{{
      translations.pointSize.text
    }}</modus-label>
    <mat-slider id="3d-settings-point-size" [min]="1" [max]="10" [step]="1" class="min-w-[60px]">
      <input modus-input matSliderThumb [formControl]="formGroup.controls.pointSize" />
    </mat-slider>
  </div>

  <modus-label class="text-xs mt-1">{{ translations.renderingMode.text }}</modus-label>

  <div class="mt-1">
    <select
      modus-select
      id="3d-settings-rendering-mode-select"
      [formControl]="formGroup.controls.renderingMode"
    >
      <option [value]="scan3dStyleRenderingMode.Rgb">
        {{ translations.renderingMode.rgb.text }}
      </option>

      <option [value]="scan3dStyleRenderingMode.Classification">
        {{ translations.renderingMode.classification.text }}
      </option>

      @if (hasClearanceFeature()) {
        <option [value]="scan3dStyleRenderingMode.Clearance">
          {{ translations.renderingMode.clearance.text }}
        </option>
      }
      @if (hasElevationFeature()) {
        <option [value]="scan3dStyleRenderingMode.Elevation">
          {{ translations.renderingMode.elevation.text }}
        </option>
      }
    </select>
  </div>

  @if (showRgbSettings()) {
    <sd-scan-3d-rgb
      [scandataModel]="scandataModel()"
      [scan3dStyle]="scan3dStyle()"
      (styleChange)="onStyleChange($event)"
    ></sd-scan-3d-rgb>
  }

  @if (showScanClassifications()) {
    <sd-scan-3d-classification
      [scandataModel]="scandataModel()"
      [scan3dStyle]="scan3dStyle()"
      (styleChange)="onStyleChange($event)"
    ></sd-scan-3d-classification>
  }

  @if (showGlobalClassificationSettings()) {
    <sd-scan-3d-global-classification
      [scan3dStyle]="scan3dStyle()"
      (styleChange)="onStyleChange($event)"
    ></sd-scan-3d-global-classification>
  }

  @if (showClearanceSettings()) {
    <sd-scan-3d-clearance
      [scan3dStyle]="scan3dStyle()"
      [scan3dStyleUom]="scan3dStyleUom()"
      (styleChange)="onStyleChange($event)"
    ></sd-scan-3d-clearance>
  }

  @if (showElevationSettings()) {
    <sd-scan-3d-elevation
      [elevationPicking]="elevationPicking()"
      [scan3dStyle]="scan3dStyle()"
      [scan3dStyleUom]="scan3dStyleUom()"
      (elevationPickClick)="onElevationPickClick()"
      (styleChange)="onStyleChange($event)"
    ></sd-scan-3d-elevation>
  }

  @if (showExperimental()) {
    <div class="flex flex-col border-t border-gray-1 text-sm mt-3">
      <div class="flex w-full justify-center mt-3">{{ translations.experimental.text }}</div>

      <div class="flex w-full items-center">
        <modus-label class="text-xs grow">{{ translations.pointBudget.text }}</modus-label>
        <mat-slider
          id="3d-settings-point-budget"
          [min]="10000000"
          [max]="40000000"
          [step]="10000000"
          class="min-w-[60px] h-8"
        >
          <input modus-input matSliderThumb [formControl]="formGroup.controls.pointBudget" />
        </mat-slider>
      </div>

      <div class="flex w-full items-center">
        <modus-label class="text-xs grow">{{ translations.pointDensity.text }}</modus-label>
        <mat-slider
          id="3d-settings-point-density"
          [min]="0.5"
          [max]="3.0"
          [step]="0.5"
          class="min-w-[60px] h-8"
        >
          <input
            class="max-h-8"
            modus-input
            matSliderThumb
            [formControl]="formGroup.controls.pointDensity"
          />
        </mat-slider>
      </div>

      @if (showStationIconCullingDistanceSettings()) {
        <div class="flex w-full items-center">
          <modus-label class="text-xs grow">{{
            translations.stationIconCullingDistance.text
          }}</modus-label>
          <modus-label class="text-xs mr-2">
            {{ formGroup.controls.stationIconCullingDistance.value }}m
          </modus-label>
          <mat-slider
            id="3d-settings-station-icon-culling-distance"
            [min]="100"
            [max]="2000"
            [step]="100"
            class="min-w-[60px]"
          >
            <input
              modus-input
              matSliderThumb
              [formControl]="formGroup.controls.stationIconCullingDistance"
            />
          </mat-slider>
        </div>
      }

      @if (showMinStationIconsPerScanSettings()) {
        <div class="flex w-full items-center">
          <modus-label class="text-xs grow">{{
            translations.minStationIconsPerScan.text
          }}</modus-label>
          <modus-label class="text-xs mr-2">
            {{ formGroup.controls.minStationIconsPerScan.value }}
          </modus-label>
          <mat-slider
            id="3d-settings-min-station-icons-per-scan"
            [min]="1"
            [max]="50"
            [step]="1"
            class="min-w-[60px]"
          >
            <input
              modus-input
              matSliderThumb
              [formControl]="formGroup.controls.minStationIconsPerScan"
            />
          </mat-slider>
        </div>
      }

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{
          translations.eyeDomeLighting.radius.text
        }}</modus-label>
        <modus-label class="text-xs">1.4</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{
          translations.eyeDomeLighting.strength.text
        }}</modus-label>
        <modus-label class="text-xs">0.7</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{ translations.pointBudget.text }}</modus-label>
        <modus-label class="text-xs">{{ formGroup.controls.pointBudget.value }}</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{ translations.pointDensity.text }}</modus-label>
        <modus-label class="text-xs">{{ formGroup.controls.pointDensity.value }}</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{ translations.pointSize.text }}</modus-label>
        <modus-label class="text-xs">{{ formGroup.controls.pointSize.value }}</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{ translations.pointShape.text }}</modus-label>
        <modus-label class="text-xs">{{ pointShapeValue() }}</modus-label>
      </div>

      <div class="flex w-full items-center mt-2">
        <modus-label class="text-xs grow">{{ translations.sizeAttenuation.text }}</modus-label>
        <modus-label class="text-xs">{{ sizeAttenuationValue() }}</modus-label>
      </div>
    </div>
  }
</div>
